import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map, Observable, switchMap} from "rxjs";
import { baseUrl } from '../../../../constants/base-url';
import {bankDetailsResourceType} from "../configs/bank-details-modal-config";
import {RecordData} from "../../../../types/records-table.types";
import {BaseModalApiService} from "../../services/base-modal-api.service";
import {CreateBankDetailsParams} from "../types/bank-details-modal.types";

@Injectable({
  providedIn: 'root'
})
export class BankDetailsModalApiService {
  private http: HttpClient = inject(HttpClient);
  private url: string = `${baseUrl}/${bankDetailsResourceType.path}`;
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);

  public createBankDetails({ recordData, recordCalendarId }: CreateBankDetailsParams): Observable<RecordData> {
    return this.http.post<RecordData>(`${this.url}`, recordData).pipe(
      switchMap((createData: RecordData) => {
        return this.baseModalApiService.attachRecordData({
          recordCalendarId: recordCalendarId,
          id: Number(createData.id),
          path: bankDetailsResourceType.path
        }).pipe(
          map(() => createData)
        );
      })
    );
  }
}
